export default __webpack_public_path__ + "static/media/Probiotics.80895771.jpg";